import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'trigger_error',
  stateProp: 'triggerError',
  defaultState: {
    triggerError: {}
  },
  handler(error) {
    return { error };
  },
  reduce(state, { error }) {
    return {
      triggerError: error
    };
  }
});
